const settings: ClientSettings = {
  name: "Banese",
  benefitCardName: "Cartão Benefício",
  theme: {
    token: {
      colorPrimary: "#256136",
      colorHighlight: "#A2C037",
    },
  },
  assets: {
    background: "/bg-banese.webp",
    logo: "/logo-banese.png",
    favicon: "/favicon-banese.png",
    card: "/card-banese.png",
    consignedCard: "/card-banese.png",
  },
  cardExclusiveTheme: {
    name: "Banese",
    theme: {
      token: {
        colorPrimary: "#256136",
        colorHighlight: "#A2C037",
      },
    },
    assets: {
      background: "/bg-banese.webp",
      logo: "/logo-banese.png",
      favicon: "/favicon-banese.png",
    },
  },
};

export default settings;
